<template>
	<v-row class="ma-0 pb-offset">
        <!-- Card Sicurezza 2FA -->
        <v-col cols="12" class="pa-0 mb-4">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Sicurezza</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 a-2">
                    <v-subheader>Autenticazione</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings2fa['2fa']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Autenticazione 2 Fattori</v-list-item-title>
                            <v-list-item-subtitle>Attiva l'autenticazione a due fattori per gli utenti obbligandoli a
                                inserire un codice di verifica (attivando l'opzione verranno disconnessi tutti gli utenti)
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settingsSso['sso_required']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Accesso solo tramite SSO</v-list-item-title>
                            <v-list-item-subtitle>Gli utenti potranno entrare solo con il proprio account Google o
                                Microsoft e il login con email e password verrà rifiutato (attivando l'opzione verranno
                                disconnessi tutti gli utenti). Chi entra dal provider non inserisce il codice a due
                                fattori, perché l'autenticazione forte è delegata al provider stesso: assicurati che sul
                                tuo tenant Google o Microsoft l'autenticazione a più fattori sia attiva, perché da qui
                                non possiamo verificarlo.
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="mx-2" color="primary" @click.native="saveSicurezza">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>

        <!-- Card Tariffe Orarie Standard -->
        <v-col cols="12" class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Tariffe Orarie Standard</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 a-2">
                    <v-subheader>Configurazione Fasce Orarie</v-subheader>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle class="mb-3">
                                Configura le fasce orarie standard che verranno utilizzate come template di default per i nuovi utenti
                            </v-list-item-subtitle>

                            <hourly-rates-editor
                                :field="{
                                    label: 'Configurazione Tariffe Vendita Standard',
                                    key: 'default_hourly_rates_sale_config',
                                    rate_type: 'sale',
                                    rate_label: 'Tariffa',
                                    rate_suffix: '€/h'
                                }"
                                :model="settings"
                                ref="default_hourly_rates_sale_config"
                                class="mb-4"
                            ></hourly-rates-editor>

                            <hourly-rates-editor
                                :field="{
                                    label: 'Configurazione Costi Operatore Standard',
                                    key: 'default_hourly_rates_cost_config',
                                    rate_type: 'cost',
                                    rate_label: 'Costo',
                                    rate_suffix: '€/h'
                                }"
                                :model="settings"
                                ref="default_hourly_rates_cost_config"
                            ></hourly-rates-editor>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import HourlyRatesEditor from '@/components/common/HourlyRatesEditor.vue'

    export default {
        name: 'users-options',
		mixins: [SettingsOptionsMixin],
		components: {
			HourlyRatesEditor
		},
        props: {},
        data() {
            return {
                model: 'users',
				settings2fa: {
					'2fa': false
				},
				settingsSso: {
					'sso_required': false
				},
				// Riattivare l'obbligo quando era gia' attivo revocherebbe di
				// nuovo i token di tutti: si salva solo se il valore cambia.
				ssoRequiredIniziale: false,
                settings: {
					default_hourly_rates_sale_config: {},
					default_hourly_rates_cost_config: {}
                },
            }
        },

        created() {
			// Carica il setting 2fa separatamente
			this.axios.get('settings/'+this.model).then(response => {
				response.data.settings.forEach((setting) => {
					if (setting.key == '2fa') {
						this.$set(this.settings2fa, '2fa', setting.value)
					}
					if (setting.key == 'sso_required') {
						this.$set(this.settingsSso, 'sso_required', !!setting.value)
						this.ssoRequiredIniziale = !!setting.value
					}
				})
			})
            this.$store.commit('endProgress')
        },

        methods: {
            saveSicurezza(action = null) {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    } else {
                        let data = {model: this.model}
                        _.forEach(this.settings2fa, (value, key) => {
                            data[key] = value == undefined ? null : value
                        })

                        this.axios.post('settings/2fa', data).then(response => {
                            this.$store.commit('SET_SETTINGS', response.data.settings)
                            this.salvaObbligoSso()
                        }, response => {
                            this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni non salvate', value: true, color: 'error'})
                        })
                    }
                }).catch(() => {

                })
            },

            // Il backend revoca i token di tutti gli utenti a ogni attivazione,
            // quindi si chiama solo a valore cambiato: risalvare la scheda con
            // l'obbligo gia' attivo butterebbe fuori tutti senza motivo.
            salvaObbligoSso() {
                const sso = !!this.settingsSso['sso_required']

                if (sso === this.ssoRequiredIniziale) {
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni salvate', value: true, color: 'success'})
                    return
                }

                this.axios.post('settings/sso', {sso: sso}).then(response => {
                    this.ssoRequiredIniziale = sso
                    this.$store.commit('SET_SETTINGS', response.data.settings)
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: sso ? 'Accesso solo tramite SSO attivato: tutti gli utenti sono stati disconnessi' : 'Impostazioni salvate',
                        value: true,
                        color: 'success'
                    })
                }, response => {
                    // Salvataggio parziale: il 2FA e' gia' andato a buon fine,
                    // dirlo evita che si creda di dover rifare tutto.
                    this.$store.commit('setSnackbar', {timeout: 8000, text: 'Autenticazione a 2 fattori salvata, ma l\'obbligo di accesso via SSO non è stato aggiornato: riprova.', value: true, color: 'error'})
                })
            },
        }
    }
</script>

<style scoped>

</style>